import React, { useState } from 'react';
import './Contact.css';

const GOOGLE_SCRIPT_ENDPOINT =
  'https://script.google.com/macros/s/AKfycbwnlilxzfAvrt9q55F3cRU-DqeTn0ooVfwZv_N_OVA9VTFXlphQzEtrwtD-HXTydw7cOg/exec';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    carReg: '',
    subject: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setErrorMessage('');

    try {
      const response = await fetch(GOOGLE_SCRIPT_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain;charset=utf-8',
        },
        body: JSON.stringify({
          formType: 'contact',
          ...formData,
        }),
      });

      if (!response.ok) {
        throw new Error('Unable to submit contact form. Please try again.');
      }

      setSubmitted(true);
      setFormData({ name: '', email: '', phone: '', carReg: '', subject: '', message: '' });
      setTimeout(() => {
        setSubmitted(false);
      }, 3000);
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="contact-page">
      {/* Header */}
      <section className="contact-header">
        <div className="container">
          <h1>Contact Us</h1>
          <p>Get in touch with West Drayton Body Works</p>
        </div>
      </section>

      <div className="container p-40">
        <div className="contact-layout">
          {/* Contact Form */}
          <section className="contact-form-section">
            <h2>Send us a Message</h2>
            <p className="form-intro">
              Fill out the form below and we'll get back to you as soon as possible.
            </p>

            {submitted && (
              <div className="success-message">
                ✓ Thank you! We've received your message and will contact you shortly.
              </div>
            )}

            {errorMessage && <div className="error-message">{errorMessage}</div>}

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your@email.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="02045793699"
                />
              </div>

              <div className="form-group">
                <label htmlFor="carReg">Car Registration Details</label>
                <input
                  type="text"
                  id="carReg"
                  name="carReg"
                  value={formData.carReg}
                  onChange={handleChange}
                  placeholder="e.g., AB21 XYZ"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="What is this about?"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Tell us more about your inquiry..."
                  rows="6"
                />
              </div>

              <button type="submit" className="btn btn-primary btn-large" disabled={submitting}>
                {submitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </section>
        </div>
      </div>

      {/* Map Section */}
      <section className="map-section">
        <div className="container">
          <h2 className="text-center">Find Us</h2>
          <div className="map-container">
            <div className="map-placeholder">
              📍 Unit 4 The Common, West Drayton, UB7 7EG, United Kingdom
            </div>
          </div>
        </div>
      </section>

      {/* Quick Contact Section */}
      <section className="quick-contact p-40">
        <div className="container">
          <h2 className="text-center">Quick Contact</h2>
          <div className="grid grid-3">
            <a href="tel:02045793699" className="quick-contact-card">
              <span className="quick-icon">☎️</span>
              <h3>Call Us</h3>
              <p>02045793699</p>
              <p className="quick-desc">Direct phone support</p>
            </a>

            <a href="https://wa.me/447888396099" className="quick-contact-card">
              <span className="quick-icon">💬</span>
              <h3>WhatsApp</h3>
              <p>7888 396099</p>
              <p className="quick-desc">Instant messaging</p>
            </a>

            <a href="mailto:support@westdraytonbodyworks.com" className="quick-contact-card">
              <span className="quick-icon">✉️</span>
              <h3>Email</h3>
              <p>support@westdraytonbodyworks.com</p>
              <p className="quick-desc">Send us your inquiry</p>
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
